import { render, staticRenderFns } from "./sidePane.vue?vue&type=template&id=e0bdfb24"
import script from "./sidePane.vue?vue&type=script&lang=js"
export * from "./sidePane.vue?vue&type=script&lang=js"
import style0 from "./sidePane.vue?vue&type=style&index=0&id=e0bdfb24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports